const REFERRAL_STORAGE_KEY = "scorevision_referral_code"

/** Query parameter carried by a share link: https://app/?ref=ABCD1234 */
export const REFERRAL_QUERY_PARAM = "ref"

export const referralShareUrl = (code: string) =>
    `${window.location.origin}/?${REFERRAL_QUERY_PARAM}=${encodeURIComponent(code)}`

/**
 * A visitor lands through a share link long before they reach the signup form, so the code is
 * parked in local storage and read back when the account is finally created.
 */
export const captureReferralCode = (search: string = window.location.search): string | undefined => {
    const code = new URLSearchParams(search).get(REFERRAL_QUERY_PARAM)
    if (!code) return storedReferralCode()

    const normalized = code.trim().toUpperCase()
    try {
        window.localStorage.setItem(REFERRAL_STORAGE_KEY, normalized)
    } catch (e) {
        // Private browsing denies storage, the code simply is not remembered
    }
    return normalized
}

export const storedReferralCode = (): string | undefined => {
    try {
        return window.localStorage.getItem(REFERRAL_STORAGE_KEY) || undefined
    } catch (e) {
        return undefined
    }
}

/** Called once the referral has been used, so a later signup does not reuse a stale code */
export const clearReferralCode = () => {
    try {
        window.localStorage.removeItem(REFERRAL_STORAGE_KEY)
    } catch (e) {
        // Nothing to clear when storage is unavailable
    }
}
